<template>
  <div class="container">
    <el-row>
      <el-col>
        <el-form :inline="true" size="small">
          <el-form-item label="组织" v-if="$store.state.isAreaOrAbove">
            <el-select v-model="listQuery.Search.StrOrganizationID" placeholder="请选择" @change="getSWList">
              <el-option
                  v-for="item in OrganizationList"
                  :key="item.StrID"
                  :label="item.StrName"
                  :value="item.StrID"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="书屋">
            <el-select v-model="listQuery.Search.StrLibraryID" placeholder="请选择">
              <el-option
                  v-for="item in swList"
                  :key="item.StrID"
                  :label="item.StrName"
                  :value="item.StrID"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="图书名">
            <el-input v-model="listQuery.Search.StrPositiveTitle" placeholder="请输入图书名"/>
          </el-form-item>
          <el-form-item>
            <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="listQuery.Search.DTStartCreatedDate"
                type="date"
                placeholder="开始时间"
                value-format="YYYY-MM-DD"
                :disabled-date="disabledDate"
                @change = "choose"
            />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="listQuery.Search.DTEndCreatedDate"
                type="date"
                placeholder="结束时间"
                value-format="YYYY-MM-DD"
                :disabled-date="disabledDate"
                @change = "choose"
            />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            <el-button
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="getList"
            >查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="reset"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="图书标题" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrPositiveTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column label="ISBN" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrISBN}}</span>
        </template>
      </el-table-column>
      <el-table-column label="图书册数" align="center">
        <template v-slot="{row}">
          <span>{{ row.TotalCount}}</span>
        </template>
      </el-table-column>
      <el-table-column label="总金额" align="center">
        <template v-slot="{row}">
          <span>{{ row.CostCount}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="total>=5" style="margin-top:50px;text-align:right;">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.Perpage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>
  </div>
</template>

<script>
import {ElMessage} from "element-plus";
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import {BASE_URL} from "@/utils/constants";
import {toUTCDateTime} from "@/utils/date";
export default {
  name:'BookMsgStatistics',
  computed: {
    zhCn() {
      return zhCn
    }
  },
  data() {
    return {
      list: null,
      listLoading: true,
      listQuery: {
        Page: 1,
        Perpage: 10,
        Search:{}
      },
      listQuerySchool: {
        Page: 1,
        Perpage: 50,
        Search:{}
      },
      libraryQuery: {
        Page: 1,
        Perpage: 999,
        Sort:"-1",
        OrderBy: "DTCreatedDate",
        Search:{}
      },
      total: 0,
      swList: [],
      Url: ''
    }
  },
  created() {
    //刷新是否是区域管理员
    this.$store.commit('changeIsAreaOrAbove');
    if (!this.$store.state.isAreaOrAbove){ this.getSWList()}else { this.getorglist()}
    this.getList()
  },
  methods: {
      disabledDate (time)  {
          return time.getTime() > Date.now()
      },
      choose(){
          const day1 = new Date(this.listQuery.Search.DTStartCreatedDate)
          const day2 = new Date(this.listQuery.Search.DTEndCreatedDate)
          if (day2.getTime() < day1.getTime()){
              ElMessage.error('日期选择错误')
              this.listQuery.Search.DTEndCreatedDate = ''
          }
      },
    getList() {
      // eslint-disable-next-line no-unused-vars
      const parem = {
        Page: this.listQuery.Page,
        Perpage: this.listQuery.Perpage,
        Search: {}
      };

      // 只在条件非空且非 undefined 时添加参数
      if (this.listQuery.Search.StrLibraryID !== undefined && this.listQuery.Search.StrLibraryID !== '' && this.listQuery.Search.StrLibraryID !== null) {
        parem.Search.StrLibraryID = this.listQuery.Search.StrLibraryID;
      }
      if (this.listQuery.Search.StrPositiveTitle !== undefined && this.listQuery.Search.StrPositiveTitle !== '' && this.listQuery.Search.StrPositiveTitle !== null) {
        parem.Search.StrPositiveTitle = this.listQuery.Search.StrPositiveTitle;
      }

      if (this.listQuery.Search.StrOrganizationID !== undefined && this.listQuery.Search.StrOrganizationID !== '' && this.listQuery.Search.StrOrganizationID !== null) {
        parem.Search.StrOrganizationID = this.listQuery.Search.StrOrganizationID;
      }

      // 处理日期范围，确保时间参数非空且有效
      var end = this.listQuery.Search.DTEndCreatedDate;
      if (end !== undefined && end !== null && end !== '' && end !== 'null') {
        var start = this.listQuery.Search.DTStartCreatedDate;
        if (start !== undefined && start !== null && start !== '' && start !== 'null') {
          parem.Search.DTStartCreatedDate = toUTCDateTime(this.listQuery.Search.DTStartCreatedDate, 'start');
        }
        parem.Search.DTEndCreatedDate = toUTCDateTime(this.listQuery.Search.DTEndCreatedDate, 'end');
      }

      this.listLoading = true;

      this.$axios({
        url: BASE_URL + 'organizations/bookscount',
        method: 'post',
        data: JSON.stringify(parem),
        // 发送格式为 json
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
          for (var i = 0; i < this.list.length; i++) {
            var cost = this.list[i].CostCount;
            let point = String(cost).length - (String(cost).indexOf('.') + 1);
            // 带有小数且超过两位小数
            if (String(cost).indexOf('.') !== -1 && point > 2) {
              this.list[i].CostCount = cost.toFixed(2);
            }
          }
          this.listLoading = false;
        }
      });
    },
    //重置
    reset(){
      this.listQuery={
        Page: 1,
            Perpage: 10,
            Search:{}
      },
      this.libraryQuery={
            Page: 1,
            Perpage: 999,
            Sort:"-1",
            OrderBy: "DTCreatedDate",
            Search:{}
      },
      this.getList();
    },
    // 获取书屋
    getSWList() {
      if (!this.$store.state.isAreaOrAbove){
        //普通管理员
        this.$axios({
          url: BASE_URL + 'librarys',
          method: 'get',
          //发送格式为json
          headers:
              {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
        }).then(res => {
          if (res.data.ok) {
            this.swList = res.data.msg
          }
        })
      }else{
        //区域管理员
        this.libraryQuery.Search.StrOrganizationID=this.listQuery.Search.StrOrganizationID
        this.$axios({
          url: BASE_URL + 'librarys/search',
          method: 'post',
          data: JSON.stringify(this.libraryQuery),
          //发送格式为json
          headers:
              {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
        }).then(res => {
          if (res.data.ok) {
            this.swList = res.data.msg
          }
        })
      }

    },
    //获取学校
    getorglist(){
      this.$axios({
        url: BASE_URL + 'organizations/search',
        method: 'post',
        data: JSON.stringify(this.listQuerySchool),
        //发送格式为json
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.ok) {
          this.OrganizationList = res.data.msg
        }
      })
    },
    // 分页
    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage
      this.getList()
    },
    currPageChange(Page) {
      this.listQuery.Page = Page
      this.getList()
    }
  }
}
</script>

